// src/pages/Login.js
import React, { useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';

const UserLogin = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const navigate = useNavigate();

  const handleChange = (e) => { 
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleLogin = (e) => {
    e.preventDefault();
    const { email, password } = form;

    if (!email || !password) {
      alert('Please fill in all fields.');
      return;
    }

    const usersRef = ref(db, 'users');
    onValue(usersRef, (snapshot) => {
      let loggedIn = false;

      snapshot.forEach((child) => {
        const user = child.val();
        if (user.email === email && user.password === password) {
          loggedIn = true;
          if (user.role === 'admin') {
            alert('Admin login successful!');
            navigate('/Admin-home');
          } else if (user.role === 'user') {
            alert('User login successful!');
            navigate('/'); // Redirect to normal home page
          }
        }
      });

      if (!loggedIn) {
        alert('Invalid credentials');
      }
    });
  };

  return (
    <div style={styles.container}>
      <h2>Login</h2>
      <form onSubmit={handleLogin} style={styles.form}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button}>Login</button>
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '50px auto',
    padding: '30px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    background: '#fff',
    textAlign: 'center',
    fontFamily: 'Segoe UI, sans-serif'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  input: {
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '16px'
  },
  button: {
    padding: '12px',
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer'
  }
};

export default UserLogin;
